/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StickyHeaderComponent} from './sticky-header.component';
import {RouterModule} from '@angular/router';
import {StickyHeaderSimpleButtonComponent} from './html-elements/sticky-header-simple-button.component';
import {StickyHeaderIconButtonComponent} from './html-elements/sticky-header-icon-button.component';
import {StickyHeaderInnerSeparatorComponent} from './html-elements/sticky-header-inner-separator.component';
import {StickyHeaderBaseComponent} from './html-elements/sticky-header-base.component';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [
        StickyHeaderComponent,
        StickyHeaderBaseComponent,
        StickyHeaderSimpleButtonComponent,
        StickyHeaderIconButtonComponent,
        StickyHeaderInnerSeparatorComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        LoadingSpinnerModule,
        TooltipModule
    ],
    exports: [StickyHeaderComponent, StickyHeaderIconButtonComponent]
})
export class StickyHeaderModule {
}
